@if (showLdr) {
<ds-loading></ds-loading>
}

<!-- Brand Header -->
<div
  class="relative mb-4 overflow-hidden cstmmrgin"
  style="background: white; border-bottom: 1px solid #e5e7eb"
>
  <!-- Top accent stripe: red + teal brand colors -->
  <div
    style="
      height: 3px;
      background: linear-gradient(
        90deg,
        #e53e3e 0%,
        #e53e3e 40%,
        #0f766e 40%,
        #0f766e 100%
      );
    "
  ></div>
  <div
    class="flex items-center justify-between flex-wrap gap-2 px-5 py-1 relative"
  >
    <!-- Decorative background elements -->
    <div
      class="absolute inset-0"
      style="pointer-events: none; overflow: hidden"
    >
      <div
        class="absolute inset-0"
        style="
          opacity: 0.15;
          background-image: radial-gradient(
            circle,
            #0f766e 1px,
            transparent 1px
          );
          background-size: 20px 20px;
        "
      ></div>
      <div
        class="absolute inset-0"
        style="
          opacity: 0.06;
          background-image: repeating-linear-gradient(
              45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            ),
            repeating-linear-gradient(
              -45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            );
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 115px;
          top: -8px;
          width: 65px;
          height: 65px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.12);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 185px;
          bottom: -12px;
          width: 55px;
          height: 55px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.1);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 75px;
          bottom: 0px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 2px dashed rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 160px;
          top: 5px;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          border: 2px dashed rgba(229, 62, 62, 0.2);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 250px;
          top: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 230px;
          bottom: 10px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.22);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 145px;
          bottom: 5px;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.2);
        "
      ></div>
    </div>
    <!-- Left: Icon + Title -->
    <div class="relative flex items-center gap-3">
      <div
        class="flex-shrink-0 flex items-center justify-center"
        style="
          width: 42px;
          height: 42px;
          background: linear-gradient(135deg, #e53e3e, #dc2626);
          border-radius: 10px;
          box-shadow: 0 2px 6px rgba(229, 62, 62, 0.25);
        "
      >
        <svg
          style="width: 20px; height: 20px; color: #fff"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
          ></path>
        </svg>
      </div>
      <div>
        @if (clntDtls && clntDtls.length > 0 && clntDtls[0].clnt_id==7) {
        <h1
          class="font-bold mb-0"
          style="font-size: 17px; color: #134e4a; letter-spacing: 0.3px"
        >
          Ward Secretariat Wise Coverage Status @if (selectedtenantNm) {
          <span
            class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ml-2"
            style="
              background: #f0fdfa;
              color: #0f766e;
              border: 1px solid #99f6e4;
            "
          >
            {{ selectedtenantNm }}
          </span>
          }
        </h1>
        }
        <div class="flex items-center gap-2">
          <div
            style="
              width: 14px;
              height: 2px;
              background: #e53e3e;
              border-radius: 1px;
            "
          ></div>
          <p
            class="mb-0"
            style="
              font-size: 11px;
              color: #64748b;
              font-weight: 500;
              letter-spacing: 0.3px;
            "
          >
            ULB Trip Coverage Analytics
          </p>
        </div>
      </div>
    </div>
    <!-- Right: Actions -->
    <div class="relative flex items-center flex-wrap" style="gap: 8px">
      <!-- ULB Select (when multiple tenants) -->
      @if (tntLst.length > 1) {
      <div class="flex flex-col min-w-0">
        <label style="font-size: 12px; font-weight: 600; color: #64748b"
          >Select ULB:</label
        >
        <nz-select
          nzShowSearch
          [(ngModel)]="selectedtenant"
          (ngModelChange)="ontntSelect($event)"
          [ngModelOptions]="{ standalone: true }"
          style="min-width: 170px; border-radius: 6px"
        >
          @for (t of tntLst; track t) {
          <nz-option
            [nzValue]="t.tnt_id"
            [nzLabel]="t.tnt_dsply_nm"
          ></nz-option>
          }
        </nz-select>
      </div>
      }
      <!-- ULB Display (when single tenant) -->
      @if (tntLst.length == 1) {
      <div class="flex flex-col min-w-0">
        <label style="font-size: 12px; font-weight: 600; color: #64748b"
          >ULB:</label
        >
        <span class="font-semibold" style="font-size: 12px; color: #0f766e">{{
          tntLst[0].tnt_nm
        }}</span>
      </div>
      }
      <!-- Date Picker -->
      <div class="flex flex-col min-w-0">
        <label style="font-size: 12px; font-weight: 600; color: #64748b"
          >Date:</label
        >
        <nz-date-picker
          [nzDisabledDate]="disabledDate"
          [nzFormat]="dateFormat"
          [(ngModel)]="slctdDt"
          (ngModelChange)="onChange($event)"
          style="border-radius: 6px; width: 150px"
        ></nz-date-picker>
      </div>
      <!-- Go Back Button -->
      <button
        (click)="goBack()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0"
        onmouseenter="this.style.background='#e2e8f0'"
        onmouseleave="this.style.background='#f1f5f9'"
      >
        <svg
          style="width: 14px; height: 14px"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 17l-5-5m0 0l5-5m-5 5h12"
          ></path>
        </svg>
        Go Back
      </button>
    </div>
  </div>
</div>

<div class="mx-auto px-3">
  <!-- Summary Strip -->
  @if (tdyCoveredTrips && tdyCoveredTrips.length > 0) {
  <div class="cvrg-summary-strip">
    <!-- Total Vehicles -->
    @for (d of tdyCoveredTrips; track d) {
    <div class="cvrg-summary-card cvrg-border-indigo">
      <div class="cvrg-card-body">
        <div class="cvrg-card-info">
          <div class="cvrg-item-value">
            {{ d.TOT_VEHICLES === null ? "0" : d.TOT_VEHICLES }}
          </div>
          <span class="cvrg-item-label">Total Vehicles</span>
          <span
            class="cvrg-item-pct"
            style="
              font-size: 11px;
              display: block;
              margin-top: 2px;
              color: #64748b;
            "
          >
            {{ d.ASGND_VEHICLES || 0 }} Assigned |
            <a
              (click)="openUnassignedVehicles()"
              class="text-blue-600 hover:text-blue-800 cursor-pointer font-medium underline"
              >{{ d.UNASGND_VEHICLES || 0 }} Unassigned</a
            >
          </span>
        </div>
        <div class="cvrg-item-icon bg-indigo">
          <svg
            class="w-5 h-5 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    }
    <!-- Completed / Total Trips -->
    @for (d of tdyCoveredTrips; track d) {
    <div class="cvrg-summary-card cvrg-border-amber">
      <div class="cvrg-card-body">
        <div class="cvrg-card-info">
          <div class="cvrg-item-value">
            {{ d.OPERATED === null ? "0" : d.OPERATED }} /
            {{ d.TOTAL_TRIPS === null ? "0" : d.TOTAL_TRIPS }}
            <span class="cvrg-item-pct"
              >({{
                (d.OPERATED * 100) / d.TOTAL_TRIPS | number : "1.2-2"
              }}%)</span
            >
          </div>
          <span class="cvrg-item-label">Completed / Total Trips</span>
        </div>
        <div class="cvrg-item-icon bg-amber">
          <svg
            class="w-5 h-5 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    }
    <!-- Total Secretariats -->
    @for (d of tdyCoveredTrips; track d) {
    <div class="cvrg-summary-card cvrg-border-teal">
      <div class="cvrg-card-body">
        <div class="cvrg-card-info">
          <div class="cvrg-item-value">
            {{ d.TOT_SVM === null ? "0" : d.TOT_SVM }}
          </div>
          <span class="cvrg-item-label">Total Secretariats</span>
          <span
            class="cvrg-item-pct"
            style="
              font-size: 11px;
              display: block;
              margin-top: 2px;
              color: #64748b;
            "
          >
            {{ d.ASGND_SECRETARIATS || 0 }} Assigned |
            <a
              (click)="openUnassignedSecretariats()"
              class="text-blue-600 hover:text-blue-800 cursor-pointer font-medium underline"
              >{{ d.UNASGND_SECRETARIATS || 0 }} Unassigned</a
            >
          </span>
        </div>
        <div class="cvrg-item-icon bg-teal">
          <svg
            class="w-5 h-5 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    }
    <!-- Avg Coverage -->
    <div class="cvrg-summary-card cvrg-border-rose">
      <div class="cvrg-card-body">
        <div class="cvrg-card-info">
          <div class="cvrg-item-value">
            {{ avg_cvrg === null ? 0 : avg_cvrg }}%
          </div>
          <span class="cvrg-item-label">Avg Coverage</span>
        </div>
        <div class="cvrg-item-icon bg-rose">
          <svg
            class="w-5 h-5 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
            ></path>
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    <!-- Routes Defined / Total Routes -->
    @if (ttlTrpsCnt && ttlTrpsCnt.length > 0) {
    <div class="cvrg-summary-card cvrg-border-sky">
      <div class="cvrg-card-body">
        <div class="cvrg-card-info">
          <div class="cvrg-item-value">
            {{ ttlTrpsCnt[0].rts_dfnd || 0 }} /
            {{
              (ttlTrpsCnt[0].rts_dfnd || 0) + (ttlTrpsCnt[0].rts_not_dfnd || 0)
            }}
            @if ((ttlTrpsCnt[0].rts_dfnd || 0) + (ttlTrpsCnt[0].rts_not_dfnd ||
            0) > 0) {
            <span class="cvrg-item-pct"
              >({{
                ((ttlTrpsCnt[0].rts_dfnd || 0) * 100) /
                  ((ttlTrpsCnt[0].rts_dfnd || 0) +
                    (ttlTrpsCnt[0].rts_not_dfnd || 0)) | number : "1.2-2"
              }}%)</span
            >
            }
          </div>
          <span class="cvrg-item-label">Routes Defined / Total Routes</span>
        </div>
        <div class="cvrg-item-icon bg-sky">
          <svg
            class="w-5 h-5 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    }
  </div>
  }

  <!-- Ward Secretariat wise Trip Coverage Table -->
  <div class="cvrg-section-card">
    <div class="cvrg-section-header">
      <div class="flex items-center gap-2">
        <svg
          class="w-5 h-5 text-indigo-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
          ></path>
        </svg>
        <h2 class="cvrg-section-title">
          Ward Secretariat wise Trip Coverage Status
        </h2>
      </div>
    </div>
    <div class="cvrg-grid-section">
      <app-data-grid
        [legacyTotalItems]="ttlColumnDefs"
        id="gridContainer"
        style="width: 100%"
        [dataSource]="tripsData"
        [legacyColumns]="columnDefs"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="true"
        exportFileName="ulb wise operated Trips"
        [pageSize]="10"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [wordWrapEnabled]="false"
        (cellClick)="devCellclk(columnDefs, $event)"
        [cellPrepared]="bound_onCellPrepared"
      >
      </app-data-grid>
    </div>
  </div>

  <!-- Chart + Top 10 Row -->
  <div class="cvrg-equal-row mt-4">
    <div class="cvrg-equal-col">
      <div class="cvrg-section-card">
        <div class="cvrg-section-header">
          <div class="flex items-center gap-2">
            <svg
              class="w-5 h-5 text-purple-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
              ></path>
            </svg>
            <h2 class="cvrg-section-title">Coverage in Last 7 Days</h2>
          </div>
        </div>
        <div id="coverageChart"></div>
      </div>
    </div>
    <div class="cvrg-equal-col">
      <div class="cvrg-section-card">
        <div class="cvrg-section-header">
          <div class="flex items-center gap-2">
            <svg
              class="w-5 h-5 text-amber-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
              ></path>
            </svg>
            <h2 class="cvrg-section-title">
              Ward Secretariat wise Top 10 Coverages
            </h2>
          </div>
        </div>
        <div class="cvrg-grid-section top10-grid">
          <app-data-grid
            id="gridContainer"
            style="width: 100%"
            [dataSource]="toptripsData"
            [legacyColumns]="topTripscolumnDefs"
            [searchPanel]="true"
            [filterRow]="false"
            [filterPanel]="false"
            [groupPanel]="true"
            [columnChooser]="true"
            [allowExport]="true"
            exportFileName="Ward Secretariat wise Top 10 Coverages"
            [pageSize]="10"
            [showPageSizeSelector]="false"
            [rowAlternationEnabled]="true"
            [showBorders]="true"
            [wordWrapEnabled]="false"
          >
          </app-data-grid>
        </div>
      </div>
    </div>
  </div>

  <!-- Unassigned Vehicles Modal -->
  <nz-modal
    [(nzVisible)]="showUnassignedVehiclesModal"
    nzTitle="Unassigned Vehicles"
    (nzOnCancel)="closeUnassignedModals()"
    [nzFooter]="null"
    nzWidth="900px"
    nzClassName="prkngdtls"
  >
    <ng-container *nzModalContent>
      <app-data-grid
        [dataSource]="unassignedVehicles"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="false"
        [columnChooser]="false"
        [allowExport]="true"
        exportFileName="Unassigned Vehicles"
        [pageSize]="10"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
      >
        <app-grid-column
          dataField="sno"
          caption="S.No"
          [width]="60"
          alignment="center"
        ></app-grid-column>

        <app-grid-column
          dataField="id"
          caption="Vehicle ID"
          [visible]="false"
        ></app-grid-column>

        <app-grid-column
          dataField="name"
          caption="Vehicle Number"
        ></app-grid-column>

        <app-grid-column
          dataField="category"
          caption="Vehicle Category"
        ></app-grid-column>

        <app-grid-column dataField="ulb" caption="ULB"></app-grid-column>

        <app-grid-column
          dataField="status"
          caption="Vehicle Status"
        ></app-grid-column>

        <app-grid-column
          dataField="reason"
          caption="Reason (Not Assigned)"
        ></app-grid-column>
      </app-data-grid>
    </ng-container>
  </nz-modal>

  <!-- Unassigned Secretariats Modal -->
  <nz-modal
    [(nzVisible)]="showUnassignedSecretariatsModal"
    nzTitle="Unassigned Secretariats"
    (nzOnCancel)="closeUnassignedModals()"
    [nzFooter]="null"
    nzWidth="900px"
    nzClassName="prkngdtls"
  >
    <ng-container *nzModalContent>
      <app-data-grid
        [dataSource]="unassignedSecretariats"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="false"
        [columnChooser]="false"
        [allowExport]="true"
        exportFileName="Unassigned Secretariats"
        [pageSize]="10"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
      >
        <app-grid-column
          dataField="sno"
          caption="S.No"
          [width]="60"
          alignment="center"
        ></app-grid-column>

        <app-grid-column
          dataField="id"
          caption="Secretariat ID"
          [visible]="false"
        ></app-grid-column>

        <app-grid-column
          dataField="name"
          caption="Secretariat Name"
        ></app-grid-column>

        <app-grid-column
          dataField="code"
          caption="Secretariat Code"
        ></app-grid-column>

        <app-grid-column dataField="ulb" caption="ULB"></app-grid-column>

        <app-grid-column dataField="status" caption="Status"></app-grid-column>
      </app-data-grid>
    </ng-container>
  </nz-modal>
</div>
